// extracted by mini-css-extract-plugin
export default {"h2":"Title_h2__f06vK","h3":"Title_h3__juOEs"};